import { render, staticRenderFns } from "./transferRecord.vue?vue&type=template&id=967b4738&scoped=true&"
import script from "./transferRecord.vue?vue&type=script&lang=ts&"
export * from "./transferRecord.vue?vue&type=script&lang=ts&"
import style0 from "./transferRecord.vue?vue&type=style&index=0&id=967b4738&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967b4738",
  null
  
)

export default component.exports